"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _AbTest = _interopRequireDefault(require("@rsuite/icon-font/lib/application/AbTest"));

// Generated by script, don't edit it please.
var AbTest = (0, _createSvgIcon["default"])({
  as: _AbTest["default"],
  ariaLabel: 'ab test',
  category: 'application',
  displayName: 'AbTest'
});
var _default = AbTest;
exports["default"] = _default;
module.exports = exports.default;